import React from 'react';
import CaseStudyTemplate from './CaseStudyTemplate';

const WayfairAiAssistantCaseStudy = () => {
  return (
    <CaseStudyTemplate
      title="Designing Wayfair's first AI virtual assistant for suppliers"
      intro="As the sole end-to-end designer, I designed everything including the conversational UX framework, streaming and uncertainity states, feedback loop, and design system from scratch. The work shipped to 11k+ suppliers and became the foundation for platform-wide AI standards across Wayfair's Partner Home."
      details={[
        { label: 'Role', value: 'Sole product designer, 0 -> 1' },
        { label: 'Team', value: 'PM, software engineers, ML scientists, data scientists, business ops' },
        { label: 'Timeline', value: 'Winter 2025 - Q1 2026' },
        { label: 'Status', value: 'Shipped to 11k+ business suppliers' },

      ]}
      heroImageSrc="/wayfair-ai-assistant.png"
      heroImageAlt="Wayfair Partner Assistant interface"
      belowHeroImage="This case study is available upon request - happy to walk through the process including design decisions, research, and implementation details."
      backTarget="selected-work"
    />
  );
};

export default WayfairAiAssistantCaseStudy;
